import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['mode', 'fixedFields', 'tripDate', 'bestPriceFields', 'searchDays'];

  connect() {
    this.refresh();
  }

  change() {
    this.refresh();
  }

  clampSearchDays() {
    if (this.searchDaysTarget.value === '') return;

    const value = Number(this.searchDaysTarget.value);
    if (!Number.isFinite(value)) return;

    const bounded = Math.min(
      Number(this.searchDaysTarget.max),
      Math.max(Number(this.searchDaysTarget.min), Math.trunc(value)),
    );
    this.searchDaysTarget.value = String(bounded);
  }

  refresh() {
    const mode = this.modeTargets.find((input) => input.checked)?.value;
    this.toggle(this.fixedFieldsTarget, this.tripDateTarget, mode === 'fixed');
    this.toggle(this.bestPriceFieldsTarget, this.searchDaysTarget, mode === 'best_price');
    if (mode === 'best_price') this.clampSearchDays();
  }

  toggle(container, input, visible) {
    container.hidden = !visible;
    input.disabled = !visible;
    input.required = visible;
  }
}
